import { Button, ConfigProvider, Flex, Layout, Menu, Typography } from 'antd';
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { CloseOutlined, MenuOutlined } from '@ant-design/icons';

import { useNavigationItemsList } from './useNavigationItemsList';

const { Sider } = Layout;
const { Text } = Typography;

const SideNavigation = () => {
  const [collapsed, setCollapsed] = useState(true);
  const location = useLocation();

  const { navigationListItems } = useNavigationItemsList(setCollapsed);
  const menuKeys = navigationListItems.map(item => item.key);

  const getActiveMenuKey = () => {
    return (
      menuKeys.find(key => location.pathname.startsWith(key)) ||
      location.pathname
    );
  };

  const [current, setCurrent] = useState(getActiveMenuKey());

  useEffect(() => {
    const activeKey = getActiveMenuKey();
    if (current !== activeKey) {
      setCurrent(activeKey);
    }
  }, [location]);

  const handleClick = e => {
    setCurrent(e.key);
  };

  return (
    <ConfigProvider
      theme={{
        components: {
          Tooltip: {
            colorBgSpotlight: '#2E3033',
            colorTextLightSolid: '#FFFFFF',
          },
        },
      }}
    >
      <Sider
        trigger={null}
        collapsible
        collapsed={collapsed}
        width={collapsed ? '48px !important' : '320px'}
        className="sider"
        style={{
          position: 'fixed',
          minHeight: '100%',
          zIndex: 5,
          paddingTop: 6,
        }}
      >
        {!collapsed && (
          <div
            style={{
              position: 'absolute',
              top: 0,
              left: 320,
              height: '100%',
              width: 'calc(100% - 320px)',
              backdropFilter: 'blur(5px)',
            }}
          />
        )}

        <Flex justify="space-between" align="center" gap="small">
          {!collapsed && (
            <Text style={{ padding: '0.75rem', color: '#FFFFFF' }}>Menu</Text>
          )}
          <Button
            style={{ color: '#FFFFFF' }}
            type="text"
            icon={collapsed ? <MenuOutlined /> : <CloseOutlined />}
            onClick={() => setCollapsed(!collapsed)}
          />
        </Flex>

        <Menu
          mode="inline"
          selectedKeys={[current]}
          onClick={handleClick}
          items={navigationListItems}
        />

        {!collapsed && (
          <Text
            style={{
              padding: '0.75rem',
              position: 'fixed',
              bottom: 0,
            }}
          >
            <small>
              Version: S{new Date().getFullYear().toString().slice(2)}-68.0.0
            </small>
          </Text>
        )}
      </Sider>
    </ConfigProvider>
  );
};

export default React.memo(SideNavigation);
